import ng from 'angular';
import angular from 'angular';
import moment from 'moment';
import { MotivocontratacaotemporariaEnum } from '../../enums/motivocontratacaotemporaria.enum';
import { TipoinclusaotemporariaEnum } from '../../enums/tipoinclusaotemporaria.enum';

export class MeurhAdmissoesContratoFormController implements ng.IController {

    static $inject = [];

    public entity: any;
    public desativaDatafimcontrato: boolean = false;
    public form: angular.IFormController;
    public desativaportrabalhadortemporario: boolean;
    public action: string;
    public tipoInclusaoOptions: Array<{ value: string, label: string }> = [];

    public anoMinimo: moment.Moment;
    public anoMaximo: moment.Moment;

    public motivocontratacaotemporariaEnum = MotivocontratacaotemporariaEnum;
    public tipoinclusaotemporariaEnum = TipoinclusaotemporariaEnum;

    constructor() {
        this.getTipoInclusaoOptions();
    }

    public $onInit(): void {
        this.verificaDatafimcontrato();
        this.bloqueiaAnoMinimo();
        this.bloqueiaAnoMaximo();

        // necessário para exibir os campos horas por mês e horas por semana corretamente como números
        if ((this.action === 'show' || this.action === 'update') && (this.entity.numerohorasmensais || this.entity.quantidademediahorassemanais)) {

            if (this.entity.numerohorasmensais) {
                const parsedHorasMensais = this.parseDecimal(this.entity.numerohorasmensais);
                if (parsedHorasMensais !== null) {
                    this.entity.numerohorasmensais = parsedHorasMensais;
                }
            }

            if (this.entity.quantidademediahorassemanais) {
                const parsedHorasSemanais = this.parseDecimal(this.entity.quantidademediahorassemanais);
                if (parsedHorasSemanais !== null) {
                    this.entity.quantidademediahorassemanais = parsedHorasSemanais;
                }
            }

        }

        this.validateHorasMensais();
        this.validateHorasSemanais();

    }

    public verificaDatafimcontrato(): void {
        if (this.entity.tipocontrato === '2') {
            this.desativaDatafimcontrato = false;
        } else {
            this.desativaDatafimcontrato = true;
            this.entity.datafimcontrato = '';
            this.entity.dataprorrogacaocontrato = '';
            if (this.form !== undefined && this.form.datafimcontrato !== undefined) {
                this.form.datafimcontrato.$error.required = false;
            }
        }
    }

    public getDiasexperienciacontrato() {
        this.calculaDatafimexperiencia();

        if (this.entity.prorrogacaoexperiencia) {
            this.calculaDatafimprorrogacao();
        }
    }

    public getProrrogacaoexperiencia(): void {
        this.calculaDatafimprorrogacao();
    }

    public calculaDatafimexperiencia(): void {
        if (
            !!this.entity.dataadmissao &&
            (this.entity.diasexperienciacontrato && this.entity.diasexperienciacontrato !== 0) &&
            this.entity.tipocontrato === '2'
        ) {
            this.entity.datafimcontrato = moment(this.entity.dataadmissao).add(this.entity.diasexperienciacontrato - 1, 'days').format('YYYY-MM-DD');
        } else if (
            !!this.entity.datafimcontrato &&
            (!this.entity.diasexperienciacontrato || this.entity.diasexperienciacontrato === 0)
        ) {
            this.entity.datafimcontrato = '';
        }
    }

    public calculaDatafimprorrogacao(): void {
        if (
            this.entity.datafimcontrato &&
            (this.entity.prorrogacaoexperiencia && this.entity.prorrogacaoexperiencia !== 0) &&
            this.entity.tipocontrato === '2'
        ) {
            this.entity.dataprorrogacaocontrato = moment(this.entity.datafimcontrato).add(this.entity.prorrogacaoexperiencia, 'days').format('YYYY-MM-DD');
        } else if (
            !this.entity.datafimcontrato ||
            (this.entity.dataprorrogacaocontrato && (!this.entity.prorrogacaoexperiencia || this.entity.prorrogacaoexperiencia === 0))
        ) {
            this.entity.dataprorrogacaocontrato = '';
        }
    }

    public motivocontratacaotemporariaChange(): void {
        delete this.entity.cpftrabalhadorsubstituido;
    }

    public exigeDiasExperienciaInicial() {
        return !this.entity.categoriatrabalhador || (this.entity.categoriatrabalhador.categoriatrabalhador !== '105' && this.entity.categoriatrabalhador.categoriatrabalhador !== '106');
    }

    public changeFimContrato() {
        if (this.entity._dataProrrogacaoContratoPeloCargo) {
            this.entity._dataProrrogacaoContratoPeloCargo = false;
            return;
        }
        this.entity.dataprorrogacaocontrato = '';
    }

    public validateHorasMensais(): void {
        if (!this.form || !this.form.numerohorasmensais) {
            return;
        }

        const rawValue = this.entity.numerohorasmensais;
        if (rawValue === null || rawValue === undefined || rawValue === '') {
            this.form.numerohorasmensais.$setValidity('number', true);
            this.form.numerohorasmensais.$setValidity('min', true);
            this.form.numerohorasmensais.$setValidity('max', true);
            return;
        }

        const parsed = this.parseDecimal(rawValue);
        const isNumber = parsed !== null;

        this.form.numerohorasmensais.$setValidity('number', isNumber);
        if (isNumber) {
            this.form.numerohorasmensais.$setValidity('min', parsed >= 1);
            this.form.numerohorasmensais.$setValidity('max', parsed <= 220);
        } else {
            this.form.numerohorasmensais.$setValidity('min', true);
            this.form.numerohorasmensais.$setValidity('max', true);
        }
    }

    public validateHorasSemanais(): void {
        if (!this.form || !this.form.quantidademediahorassemanais) {
            return;
        }

        const rawValue = this.entity.quantidademediahorassemanais;
        if (rawValue === null || rawValue === undefined || rawValue === '') {
            this.form.quantidademediahorassemanais.$setValidity('number', true);
            this.form.quantidademediahorassemanais.$setValidity('min', true);
            this.form.quantidademediahorassemanais.$setValidity('max', true);
            return;
        }

        const parsed = this.parseDecimal(rawValue);
        const isNumber = parsed !== null;

        this.form.quantidademediahorassemanais.$setValidity('number', isNumber);
        if (isNumber) {
            this.form.quantidademediahorassemanais.$setValidity('min', parsed >= 1);
            this.form.quantidademediahorassemanais.$setValidity('max', parsed <= 44);
        } else {
            this.form.quantidademediahorassemanais.$setValidity('min', true);
            this.form.quantidademediahorassemanais.$setValidity('max', true);
        }
    }

    private getTipoInclusaoOptions(): void {
        this.tipoInclusaoOptions = [
            {
                value: this.tipoinclusaotemporariaEnum.MOTIVO_INCLUSAO_LOCAIS_SEM_FILIAIS.toString(),
                label: 'Locais sem filiais',
            },
            {
                value: this.tipoinclusaotemporariaEnum.MOTIVO_INCLUSAO_ESTUDO_MERCADO.toString(),
                label: 'Estudo de mercado',
            },
            {
                value: this.tipoinclusaotemporariaEnum.MOTIVO_INCLUSAO_CONTRAT_SUPERIOR_3_MESES.toString(),
                label: 'Contratação superior a 3 meses',
            }
        ];
    }

    private parseDecimal(value: any): number | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        const normalized = String(value).replace(',', '.');
        const parsed = parseFloat(normalized);
        return Number.isNaN(parsed) ? null : parsed;
    }

    // inicio - tratamento de datas
    private bloqueiaAnoMinimo(): void {
        this.anoMinimo = moment().subtract(120, 'years'); // > 120 anos
    }

    private bloqueiaAnoMaximo(): void {
        this.anoMaximo = moment().add(100, 'years'); // > 120 anos
    }

    private getDataMinimaProrrogacaoContrato() {
        if (this.entity.datafimcontrato) {
            return moment(this.entity.datafimcontrato).add(1, 'days').format('YYYY-MM-DD');
        }
    }

    // fim - tratamento de datas
}
